module.exports = "/_next/static/images/mobile_hero_id-10f5c2e6d645c9d70d8b99abf4eb607a.webp";